

export const carrieReviewerReviewHinge = {
  _id: 'carrieReviewerReviewHingeId',
  email: 'carrie@email.com',
  profileReviewId: 'carrieProfileReviewHingeId',
  reviewerProfileId: 'carrieReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Carrie! This will really help me!',
  profileReviewedFirstName: 'Miranda',
}

export const charlotteReviewerReviewBumble = {
  _id: 'charlotteReviewerReviewBumbleId',
  email: 'charlotte@email.com',
  profileReviewId: 'charlotteProfileReviewBumbleId',
  reviewerProfileId: 'charlotteReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Charlotte! This will really help me!',
  profileReviewedFirstName: 'Miranda',
}

export const samanthaReviewerReviewTinder = {
  _id: 'samanthaReviewerReviewTinderId',
  email: 'samantha@email.com',
  profileReviewId: 'samanthaProfileReviewTinderId',
  reviewerProfileId: 'samanthaReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Samantha! This will really help me!',
  profileReviewedFirstName: 'Miranda',
}